import { render } from "./Orders.vue?vue&type=template&id=04533cca&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=04533cca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04533cca"]])

export default __exports__